import { FieldRange, MessageModel } from '@msdk/definitions'

// Keep this code for the required marker and reveal its message after blur or submit.
const DEFAULT_MANDATORY_MSG_CODE = 'FRM_00001'

export function getValidationMessagesWithRangeHelperText(
  validationMessages: string[],
  range?: FieldRange | null,
): string[] {
  const messages = [...validationMessages]

  if (messages.some((code) => code !== DEFAULT_MANDATORY_MSG_CODE) || !range) {
    return messages
  }

  const minDefined = range.min !== null && range.min !== undefined
  const maxDefined = range.max !== null && range.max !== undefined

  if (!maxDefined && !minDefined) {
    return messages
  }

  if (!minDefined) {
    return [...messages, 'FRM_RANGE_HELPER_MAX']
  }

  if (!maxDefined) {
    return [...messages, 'FRM_RANGE_HELPER_MIN']
  }

  return [...messages, 'FRM_RANGE_HELPER']
}

export function filterOutMandatoryMessages(messages: MessageModel[]): MessageModel[] {
  return messages.filter((message) => message.code !== DEFAULT_MANDATORY_MSG_CODE)
}

export function filterMessagesMatchingCodes(messages: MessageModel[], messageCodes: string[]): MessageModel[] {
  return messages.filter((message) => messageCodes.includes(message.code))
}

export function selectMostSevere(messages: MessageModel[], messageCodes: string[], count: number = 1): MessageModel[] {
  return filterMessagesMatchingCodes(messages, messageCodes)
    .sort((first, second) => first.type - second.type)
    .slice(0, count)
}
